// DensityToggle — 3-segment control wired to settings store.

import { useSettingsStore } from "@/store/settings";
import type { Density } from "@/lib/types";
import { cn } from "@/lib/cn";

const OPTIONS: Array<{ value: Density; label: string }> = [
  { value: "compact", label: "Compact" },
  { value: "cozy", label: "Cozy" },
  { value: "comfortable", label: "Comfortable" },
];

export function DensityToggle() {
  const density = useSettingsStore(s => s.density);
  const setDensity = useSettingsStore(s => s.setDensity);
  return (
    <div className="lex-segmented" role="radiogroup" aria-label="Row density">
      {OPTIONS.map(o => (
        <button
          key={o.value}
          type="button"
          role="radio"
          aria-checked={density === o.value}
          className={cn("lex-segmented__btn", density === o.value && "lex-segmented__btn--active")}
          onClick={() => setDensity(o.value)}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}

export default DensityToggle;
